import {forEach} from "lodash";

export const getPropByString = (obj, propString) => {
    if (!propString)
        return obj;

    let prop, props = propString.split('.');

    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
        prop = props[i];

        let candidate = obj[prop];
        if (candidate !== undefined) {
            obj = candidate;
        } else {
            break;
        }
    }
    return obj[props[i]];
}

export const formDataCreator = (values) => {
    let form_data = new FormData();

    for (let key in values) {
        if (Array.isArray(values[key])) {
            values[key].forEach(item => form_data.append(`${key}[]`, item))
        } else {
            form_data.append(key, values[key]);
        }
    }
    return form_data;
}

export const urlencodedDataCreator = (values) => {
    const urlencoded = new URLSearchParams();

    for (let key in values) {
        if (Array.isArray(values[key])) {
            values[key].forEach(item => urlencoded.append(`${key}[]`, item))
        } else {
            urlencoded.append(key, values[key]);
        }
    }
    return urlencoded;
}

export const tomanPrice = (value) => {
    try {
        return parseInt(value) / 10
    } catch (e) {
        return 0;
    }
}

export const ListGeneratorFromEnum = (arr) => {
    let new_arr = [];
    Object.keys(arr).map((item) =>
        new_arr.push({
            id: item,
            title: arr[item],
        })
    );
    return new_arr;
};

export const generateQueryString = (arr) => {
    let query = '?'
    Object.keys(arr).map(key => {
        if (arr[key]) {
            query += `${key}=${arr[key]}&`
        }
    })
    return query
}

export const convertBoolToNumber = (str) => {
    if (str == "true" || str == true) {
        return 1;
    } else if (str == "false" || str == false) {
        return 0;
    } else {
        return null;
    }
}

export const removeNullishValue = (values) => {
    let newObject = {}
    for (const property in values) {
        if (values[property]) {
            newObject[property] = values[property]
        }
    }
    return newObject
}


function remove(arr, ...itemsToRemove) {
    let index;
    for (let i = 0; i < itemsToRemove.length; i++) {
      while ((index = arr.indexOf(itemsToRemove[i])) !== -1) {
        arr.splice(index, 1);
      }
    }
    return arr;
  }

export function groupPermissionsByName(lst) {
    const result = {};
    for (let i = 0; i < lst.length; i++) {
        const d = lst[i];
        let parts = d.title.split('.');
        parts = remove(parts,'permissions');
        let current = result;
        for (let j = 0; j < parts.length; j++) {
            const part = parts[j];
            if (!current[part]) {
                current[part] = {};
            }
            current = current[part];
        }
        current.permissions = current.permissions || [];
        current.permissions.push(d);
    }
    return result;
}